window.addEventListener('variant-change', event => {

  const variantId = event?.detail?.variant?.id;
  const matchedMoqObj = window.brade.moqs.find(m => m.id === variantId);
  const moq = matchedMoqObj?.moq;
  const qsElement = document.querySelector('quantity-selector .quantity-selector__input');
  if(!!qsElement) {
    // The QuantitySelector helper class (empire.js) exposes itself on the
    // <quantity-selector> field element as `quantitySelectorInstance` so we
    // can update its cached `incrementValue` directly, instead of relying on
    // a custom event the class would need to listen for.
    const qsInstance = qsElement.closest('quantity-selector')?.quantitySelectorInstance;

    if (!!moq) {
      const currentValue = Number(qsElement.value);
      const nextValue =
        Number.isFinite(currentValue) &&
        currentValue > 0 &&
        currentValue % moq === 0
          ? currentValue
          : Math.max(moq, Math.round((currentValue || 0) / moq) * moq);

      qsElement.min = `${moq}`;
      qsElement.step = `${moq}`;
      qsElement.value = `${nextValue}`;
      qsElement.dataset.incrementValue = `${moq}`;
      if (qsInstance) qsInstance.incrementValue = moq;
      // enable minus buttons
      const wrappers = document.querySelectorAll('quantity-selector .quantity-selector__button-wrapper--disabled');
      wrappers.forEach(wrapper => {
        if(nextValue > moq) {
          wrapper.classList.remove('quantity-selector__button-wrapper--disabled')
        }
      });
    }
    else {
      qsElement.min = '1';
      qsElement.step = '1';
      qsElement.value = '1';
      qsElement.dataset.incrementValue = `1`;
      if (qsInstance) qsInstance.incrementValue = 1;
    }
  }

});